<template>
  <div class="ui-toast component" :class="classList" @click="remove">
    {{ item.message }}
  </div>
</template>

<script>
export default {
  name: 'UiToast',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    classList() {
      return {
        default: this.item.type === 'default',
        success: this.item.type === 'success',
        info: this.item.type === 'info',
        warning: this.item.type === 'warning',
        error: this.item.type === 'error',
      }
    },
  },

  mounted() {
    if (this.item.duration) {
      const timer = setTimeout(() => {
        clearTimeout(timer)
        this.remove()
      }, this.item.duration)
    }
  },

  methods: {
    remove() {
      this.$emit('remove', this.item.id)
    },
  },
}
</script>

<style lang="scss">
.ui-toast.component {
  padding: 20px;
  margin: 20px 0;
  cursor: pointer;
  background-color: $white;

  @include box-shadow(0 0 30px -15px rgba(0, 0, 0, 0.2));

  &.default {
    border-left: 5px solid $color-line;
  }
  &.success {
    border-left: 5px solid $green;
  }
  &.info {
    border-left: 5px solid $primary;
  }
  &.warning {
    border-left: 5px solid orange;
  }
  &.error {
    border-left: 5px solid $red;
  }
}
</style>
